<template>
    <div class="sub-tab">
        <v-container>
            <ul class="tab tab--block" v-if="page == '회사소개'">
                <li class="tab__li" :class="{ active: tabActive == '1' }">
                    <a href="/company/greeting" class="tab__btn">
                        <span>인사말</span>
                        <span class="dot"></span>
                    </a>
                    <span class="dot"></span>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '2' }">
                    <a href="/company/history" class="tab__btn">
                        <span>연혁</span>
                        <span class="dot"></span>
                    </a>
                    <span class="dot"></span>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '3' }">
                    <a href="/company/partners" class="tab__btn">
                        <span>파트너 거래처</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '4' }">
                    <a href="/company/contact" class="tab__btn">
                        <span>오시는 길</span>
                    </a>
                </li>
            </ul>

            <ul class="tab tab--block" v-if="page == '비즈니스'">
                <li class="tab__li" :class="{ active: tabActive == '1' }">
                    <a href="/business/overview" class="tab__btn">
                        <span>사업개요</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '2' }">
                    <a href="/business/vnm" class="tab__btn">
                        <span>비전&미션</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '3' }">
                    <a href="/business/process" class="tab__btn">
                        <span>프로세스</span>
                    </a>
                </li>
            </ul>

            <ul class="tab tab--block" v-if="page == '제품안내'">
                <li class="tab__li" :class="{ active: tabActive == '1' }">
                    <a href="#1" class="tab__btn">
                        <span>각종소스류</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '2' }">
                    <a href="#2" class="tab__btn">
                        <span>제과제빵류</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '3' }">
                    <a href="#3" class="tab__btn">
                        <span>공산품식자재</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '3' }">
                    <a href="#4" class="tab__btn">
                        <span>유제품</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '4' }">
                    <a href="#5" class="tab__btn">
                        <span>면류</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '5' }">
                    <a href="#6" class="tab__btn">
                        <span>냉동/냉장식품</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '6' }">
                    <a href="#7" class="tab__btn">
                        <span>육가공류</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '7' }">
                    <a href="#8" class="tab__btn">
                        <span>야채/신선식품</span>
                    </a>
                </li>
            </ul>

            <ul class="tab tab--block" v-if="page == '고객센터'">
                <li class="tab__li" :class="{ active: tabActive == '1' }">
                    <a href="/service/inquiry" class="tab__btn">
                        <span>상담문의</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '2' }">
                    <a href="/service/notice" class="tab__btn">
                        <span>공지사항</span>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="tab__li" :class="{ active: tabActive == '3' }">
                    <a href="/service/question" class="tab__btn"><span>자주 묻는 질문</span></a>
                </li>
            </ul>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        page: { type: String, default: "" },
        tabActive: { type: String, default: "" },
    },
    components: {},
    data: () => {
        return {};
    },
    created() {},
    // mounted() {
    // 	this.init();
    // },
    // methods : {
    // 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
    // 	}
    // },
};
</script>

<style scoped></style>
